import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Typography from '@segment/matcha/components/Typography'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import { SectionWithAccordion } from 'views/Infrastructure/accordionData'

import AccordionSection from '../AccordionSection'

import DeliveryDestinationsImage from './DeliveryDestinationsImage'

const data = {
  anchorId: `destinations`,
  overline: `Delivery`,
  heading: `Destinations`,
  description: `Writing integrations is fussy. There’s new APIs to learn, tricky XML and JSON parsing, authentication refreshes, and mapping little bits of data. Often these APIs have little documentation and unexpected error codes. We’ve built out our destinations to handle all of these tiny inconsistencies at scale.`,
  link1: `https://news.ycombinator.com/item?id=17499137`,
  link1Text: `Goodbye microservices (753 comments)`,
  link2: `https://news.ycombinator.com/item?id=19106767`,
  link2Text: `When AWS Autoscale Doesn’t (92 comments)`,
  accordionSection: SectionWithAccordion.DESTINATIONS,
}

const DeliveryDestinations: FC<PropsWithChildren<unknown>> = () => {
  const { anchorId, overline, heading, description, link1, link1Text, link2, link2Text, accordionSection } = data
  return (
    <Wrapper id={anchorId}>
      <SectionBase variant="2Col" copyVariant="wide">
        <Section.Copy>
          <CopyTextBase>
            <CopyText.Overline>{overline}</CopyText.Overline>
            <CopyText.Heading>{heading}</CopyText.Heading>
            <CopyText.Description tag="div">
              <CopyTextDescriptionSection>{description}</CopyTextDescriptionSection>
              <CopyTextDescriptionSection>
                <Typography variant="pLarge">
                  <a href={link1}>{link1Text}</a>
                </Typography>
              </CopyTextDescriptionSection>
              <CopyTextDescriptionSection>
                <Typography variant="pLarge">
                  <a href={link2}>{link2Text}</a>
                </Typography>
              </CopyTextDescriptionSection>
              <AccordionSection section={accordionSection} />
            </CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <StyledSectionContents>
          <DeliveryDestinationsImage />
        </StyledSectionContents>
      </SectionBase>
    </Wrapper>
  )
}

const CopyTextDescriptionSection = styled.div`
  margin-bottom: 32px;
`

const Wrapper = styled.section`
  display: grid;
`

const StyledSectionContents = styled(Section.Contents)`
  margin: auto;
`

export default DeliveryDestinations
